// extracted by mini-css-extract-plugin
export default {"wrapper":"cK","content":"eK","firstSection":"fK","text":"gK","table":"hK","tableText":"iK","row":"jK","column_2":"kK","column_1":"lK","column_3":"mK"};
    if(module.hot) {
      // 1714654894048
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  